export default __webpack_public_path__ + "static/media/folder.f825d5e1.svg";